import PolicyPage from "@/pages/PolicyPage";

const H = ({ children }) => (
  <h2 className="text-2xl font-semibold tracking-tight mt-12 mb-4 text-graphite">{children}</h2>
);

export default function Complaint() {
  return (
    <PolicyPage
      title="Complaint Procedure"
      meta="Your rights to make a complaint about the service provided by Carlton Elleker Chase."
    >
      <p className="text-xl text-graphite/85">Your rights to make a Complaint: our Complaint Procedure.</p>

      <H>Our policy</H>
      <ul className="list-disc pl-6 space-y-2">
        <li>You have the right to complain to us.</li>
        <li>You will not be charged for any time spent handling your complaint.</li>
        <li>You can request a copy of this complaint procedure at any time.</li>
        <li>
          We issue all clients with a copy of this complaint procedure:
          <ol className="list-decimal pl-6 mt-2 space-y-1">
            <li>on instruction of our firm (in a link to this policy included in our terms of business);</li>
            <li>when you raise a complaint; and</li>
            <li>at the conclusion of your matter.</li>
          </ol>
        </li>
        <li>We shall aim to deal with any complaint that we may receive promptly, fairly, openly and effectively.</li>
      </ul>

      <H>Making a complaint</H>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          We want to give you the best possible service. However, if at any point you become unhappy
          or concerned about the service we have provided then you should inform us immediately, so
          that we can do our best to resolve the problem.
        </li>
        <li>
          In the first instance it may be helpful to contact the person who is working on your case
          to discuss your concerns and we will do our best to resolve any issues at that stage.
        </li>
        <li>Making a complaint will not affect how we handle your case.</li>
        <li>
          If you need to make a complaint, you should:
          <ul className="list-[circle] pl-6 mt-2 space-y-1">
            <li>complain as soon as possible;</li>
            <li>be clear on what the issue is and how you would like it to be resolved;</li>
            <li>give us up to eight weeks to resolve your complaint.</li>
          </ul>
        </li>
      </ul>

      <H>Handling and resolving a complaint</H>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          We will provide you with a written outcome following an investigation into your complaint.
          If you are not happy with our outcome, or we have not provided you with an outcome within
          8 weeks, you can contact the Legal Ombudsman.
        </li>
        <li>
          If we cannot resolve your complaint you can speak directly to the Legal Ombudsman who can
          help. They will look at your complaint independently and it will not affect how we handle
          your case.
        </li>
        <li>
          Before accepting a complaint for investigation, the Legal Ombudsman will check that you
          have tried to resolve your complaint with us first. If that has occurred, you must make
          your complaint to them:
          <ul className="list-[circle] pl-6 mt-2 space-y-1">
            <li>within six months of receiving a final response to your complaint;</li>
            <li>no more than six years from the date of act/omission; or</li>
            <li>no more than three years from when you should reasonably have known there was cause for complaint.</li>
          </ul>
        </li>
        <li>
          If you would like more information about the Legal Ombudsman, please contact them as follows:
          <ul className="list-[circle] pl-6 mt-2 space-y-1">
            <li>
              Website:{" "}
              <a
                href="https://www.legalombudsman.org.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1E3668] hover:underline"
              >
                www.legalombudsman.org.uk
              </a>
            </li>
            <li>Phone: 0300 555 0333 between 9am and 5pm.</li>
            <li>
              Email:{" "}
              <a href="mailto:enquiries@legalombudsman.org.uk" className="text-[#1E3668] hover:underline">
                enquiries@legalombudsman.org.uk
              </a>
            </li>
          </ul>
        </li>
        <li>
          In certain circumstances, you could also refer the matter to the Solicitors Regulation
          Authority. This could be for things like misconduct, losing your money or treating you
          unfairly because of your age, a disability or other characteristic.
        </li>
      </ul>

      <p className="mt-16 text-sm text-graphite/55">Updated 19 October 2020.</p>
    </PolicyPage>
  );
}
